<template>
  <p :class="[this.class, { small, large }]">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: "P",
  props: {
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    class() {
      return this.$el ? this.$el.className : "";
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
p {
  color: $body-gray;
  font-size: $font-size-md;
  font-weight: 400;
  line-height: 1.5;

  &.large {
    font-size: $font-size-lg;
  }

  &.small {
    font-size: $font-size-sm;
  }
}
</style>
